import React from 'react';
import { useEffect, useState, useRef } from 'react'
import './gallery.css'

export const GalleryPopup = (props: { title: string, index?: number, images: string[], onClose: () => void }) => {
  const [index, setIndex] = useState<number>(props.index || 0)
  const leftKey = 'ArrowLeft', upKey = 'ArrowUp', rightKey = 'ArrowRight', downKey = 'ArrowDown', keyA = 'KeyA', keyD = 'KeyD'

  function prev() {
    setIndex(prevIndex => (prevIndex <= 0 ? 0 : prevIndex - 1));
  }

  function next() {
    setIndex(prevIndex => (prevIndex >= props.images.length - 1 ? props.images.length - 1 : prevIndex + 1));
  }

  const onKeydown = (e: KeyboardEvent) => {
    if (e.code === upKey || e.code === rightKey || e.code === keyD) {
      next()
    }
    else if (e.code === downKey || e.code === leftKey || e.code === keyA) {
      prev()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', onKeydown)
    return () => {
      document.removeEventListener('keydown', onKeydown)
    };
  }, []);

  return <div className='gallerymodal' >
    <img src={props.images[index]} />
    {index > 0 && (
      <div onClick={prev} className='prev'>
        <i className='svgfont-left'></i>
      </div>
    )}
    {index < props.images.length - 1 && (
      <div onClick={next} className='next'>
        <i className='svgfont-right'></i>
      </div>
    )}
    {/* <div onClick={closeModal} className='close'>
      <i className='svgfont-close'></i>
    </div> */}
  </div>
};
